module.exports = __WEBPACK_EXTERNAL_MODULE_221__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","platformBrowser"],"commonjs":"@angular/platform-browser","commonjs2":"@angular/platform-browser","amd":"@angular/platform-browser"}
// module id = 221
// module chunks = 0 1